module.exports = __webpack_public_path__ + "img/rongyu.4e754818.svg";